module.exports = "/_next/static/images/046430cdb02a492cf784541d83b4de14-nuconta-inclined-device@2x.png";